import API from '../../../helpers/API';
import { showLoader, hideLoader, generateCaptcha } from '../../../common/actions/commonActions';
import { SET_MENU_LIST } from '../../common/constants/ActionTypes';
import { AUTHENTICATE_USER } from '../../common/constants/endpoints';
import { toastr } from 'react-redux-toastr';
import { useNavigate } from 'react-router-dom';

export const authenticateUser = (payload) => {
  return async function (dispatch) {
    dispatch(showLoader());

    try {
      const { username, password, captchaId, enteredCaptcha} = payload;

      const response = await API.post(`${AUTHENTICATE_USER}/`, { username, password, captchaId, enteredCaptcha },
        { headers: {} });
      dispatch(hideLoader());
      if (response) {
        sessionStorage.setItem('token', response.data.jwtResponse.token);
        sessionStorage.setItem('user', JSON.stringify(response.data.userData));
      }

      payload.loginVerified && payload.loginVerified();
      payload.startSessionTimeout && payload.startSessionTimeout(1 * 60 * 1000);

    } catch (error) {
      dispatch(hideLoader());
      dispatch(generateCaptcha());
      const errorMessage =
        error.response?.data?.message || error.message;
      toastr.error(errorMessage);
    }
  };
};
